import api from "@/api/axios";

const state = {
    createAccount: null,
    etapaCadastro: null,
    PFInfoBasicas: null,
    PFInfoFinanceiras: null,
    PFInfoBancarios: null,
    PFInfoDeclaracoes: null,
    PFSalvarInfoFinanceiras: null,
    PFSalvarInfoBasicas: null,
    PFSalvarInfoBancarias: null,
    PFSalvarInfoEndereco: null,
    PFSalvarInfoDeclaracoes: null,
    listaOcupacaoProfissional: [],
    listaBancos: [],
    listaPaises: [],
    listaFormacaoProfissional: [],
    listaRamoAtividade: [],
    salvarInformacoes: false,
    PJInfoEmpresa: null,
    PJInfoBancario: null,
    PJSalvarInfoEmpresa: null,
    PJSalvarInfo: null,
    PJSalvarInfoComplementoEmpresa: null,
    PJSalvarInfoComplementoSocios: null,
    PJInfoComplementoEmpresa: null,
    PJInfoComplementoSocios: null,
    PJAddPessoa: null,
    PJAddPessoaFatca: null,
    existeResponsavelLogin: false,
    PJEditarPessoa: null,
    PJEditarPessoaPep: null,
    PJAddPessoaPep: null,
    listaRepresentantesPJ: [],
    PJInfoFinanceiraEmpresa: null,
    PJSalvarInfoFinanceiraEmpresa: null,
    PJSalvarInfoBancarias: null,
    PJSalvarInfoBancariasAdicional: null,
    PJInfoEndereco: null,
    PJSalvarInfoEndereco: null,
    PJInfoDeclaracoes: null,
    PJSalvarInfoDeclaracoes: null,
    FIInfoEmpresa: null,
    FISalvarInfoEmpresa: null,
    FISalvarInfo: null,
    FIInfoFinanceiro: null,
    FIInfoBancario: null,
    FIInfoDeclaracao: null,
    FISalvarInfoFinanceiro: null,
    FISalvarInfoBancario: null,
    FISalvarInfoDeclaracao: null,
    FISalvarInfoBancarioAdicional: null,
    FIInfoParticipante: null,
    FISalvarInfoParticipante: null,
    ModalSaibaMaisInformativo: false,
    FISalvarInfoParticipanteRepresentante: null,
    FIInfoParticipanteRepresentante: null,
    FIAddParticipante: null,
    FIEditarParticipante: null,
    FIListaParticipantes: null,
    QuestionarioModalAbrir: null,
    QuestionarioListarPerguntas: null,
    fichaConcluir: null,
    PFSalvarContasAdicionais: null,
    ModalPepInformativo: false,
    listaAtividades: [],
    listaTiposInvestidores: [],
    listaNaturezaJuridica: [],
    listaTiposClientesPJ: [],
    PFInfoBasicasRepresentantes: [],
    PFSalvarInfoBasicasRepresentantes: null,
    listaDocumentosUpload: [],
    listaDocumentosUploadRealizado: [],
    SalvarInfoUpload: null,
    listaProdutos: [],
    ModalTermosProdutos: 0,
    listaProdutosCliente: [],
    PerfilClienteQuestionario: null,
    listaNacionalidades: [],
    listaCidade: [],
    listaOrgaoEmissor: [],
    ModalDisclaimerInformativo: null,
    listaDisclaimer: [],
    listaRepresentantesFI: [],
    listaMotivoDispensa: [],
    listaProcuradoresPJ: [],
    ModalTermosDocumentosBloquearAceite: false,
    listaProcuradoresFI: [],
    FIInfoEmissorOrdem: [],
    FISalvarInfoEmissorOrdem: null,
    PF_PJ_SalvarDispensaQuestionario: null,
    PF_PJ_InfoDispensaQuestionario: null,
    DispensaQuestionarioConfig: [],
    Configuracao: [],
    Configuracoes: {},
    abrirAlterarSenha: false,
    modalAvisoLogin: false,
    modalAviso: false,
    modalAvisoGenerico: false,
    modalAvisoAprovacaoPersonalizada: false,
    listaAssinantes: [],
    ModalAssinaturaStatus: 0,
    listaAssinaturasStatus: [],
    situacaoDocumentoAssinatura: [],
    habImpressaoDocumentos: false,
    DesabilitarNotificacaoSalvar: false,
    listaPEPFI: [],
    modalCadastroVencido: false,
    etapaConcluida: [],
    salvarQuestionario: null,
    enviarCadastro: false,
    suitabilityPreview: null,
    modalVisualizarPosicao: false
};

const getters = {
    GET_CREATE_ACCOUNT: (state) => state.createAccount,

    GET_ETAPA_CADASTRO: (state) => state.etapaCadastro,

    GET_SALVAR_QUESTIONARIO: (state) => state.salvarQuestionario,

    GET_ETAPA_CONCLUIDA: (state) => state.etapaConcluida,

    GET_SUITABILITY_PREVIEW: (state) => state.suitabilityPreview,

    GET_MODAL_CADASTRO_VENCIDO: (state) => state.modalCadastroVencido,

    GET_PF_INFO_BASICAS: (state) => state.PFInfoBasicas,

    GET_PF_INFO_BASICAS_REPRESENTANTES: (state) =>
        state.PFInfoBasicasRepresentantes,

    GET_PF_SALVAR_INFO_BASICAS: (state) => state.PFSalvarInfoBasicas,

    GET_PF_SALVAR_INFO_BASICAS_REPRESENTANTES: (state) =>
        state.PFSalvarInfoBasicasRepresentantes,

    GET_PF_INFO_FINANCEIRAS: (state) => state.PFInfoFinanceiras,

    GET_PF_INFO_BANCARIOS: (state) => state.PFInfoBancarios,

    GET_PF_INFO_DECLARACOES: (state) => state.PFInfoDeclaracoes,

    GET_LISTA_BANCOS: (state) => state.listaBancos,

    GET_LISTA_PAISES: (state) => state.listaPaises,

    GET_LISTA_RAMO_ATIVIDADE: (state) => state.listaRamoAtividade,

    GET_LISTA_ATIVIDADES: (state) => state.listaAtividades,

    GET_LISTA_TIPOS_INVESTIDORES: (state) => state.listaTiposInvestidores,

    GET_LISTA_NATUREZA_JURIDICA: (state) => state.listaNaturezaJuridica,

    GET_LISTA_TIPOS_CLIENTES_PJ: (state) => state.listaTiposClientesPJ,

    GET_LISTA_NACIONALIDADES: (state) => state.listaNacionalidades,

    GET_LISTA_CIDADE: (state) => state.listaCidade,

    GET_LISTA_ORGAO_EMISSOR: (state) => state.listaOrgaoEmissor,

    GET_LISTA_OCUPACAO_PROFISSIONAL: (state) => state.listaOcupacaoProfissional,

    GET_LISTA_FORMACAO_PROFISSIONAL: (state) => state.listaFormacaoProfissional,

    GET_LISTA_DOCUMENTOS_UPLOAD: (state) => state.listaDocumentosUpload,

    GET_LISTA_DOCUMENTOS_UPLOAD_REALIZADO: (state) =>
        state.listaDocumentosUploadRealizado,

    GET_LISTA_DOCUMENTOS: (state) => state.listaDocumentosDeclaracoes,

    GET_LISTA_DOCUMENTOS_CLIENTE: (state) =>
        state.listaDocumentosDeclaracoesCliente,

    GET_PF_SALVAR_INFO: (state) => state.salvarInformacoes,

    GET_PF_SALVAR_INFO_FINANCEIRAS: (state) => state.PFSalvarInfoFinanceiras,

    GET_PF_SALVAR_INFO_BANCARIAS: (state) => state.PFSalvarInfoBancarias,

    GET_PF_SALVAR_INFO_ENDERECO: (state) => state.PFSalvarInfoEndereco,

    GET_PF_SALVAR_INFO_DECLARACOES: (state) => state.PFSalvarInfoDeclaracoes,

    GET_PJ_INFO_EMPRESA: (state) => state.PJInfoEmpresa,

    GET_PJ_SALVAR_INFO_EMPRESA: (state) => state.PJSalvarInfoEmpresa,

    GET_PJ_SALVAR_INFO: (state) => state.PJSalvarInfo,

    GET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA: (state) =>
        state.PJSalvarInfoComplementoEmpresa,

    GET_PJ_INFO_COMPLEMENTO_EMPRESA: (state) => state.PJInfoComplementoEmpresa,

    GET_PJ_INFO_COMPLEMENTO_SOCIOS: (state) => state.PJInfoComplementoSocios,

    GET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS: (state) =>
        state.PJSalvarInfoComplementoSocios,

    GET_MODAL_PJ_ADD_PESSOA: (state) => state.PJAddPessoa,

    GET_MODAL_PJ_ADD_PESSOA_FATCA: (state) => state.PJAddPessoaFatca,

    existeResponsavelLogin: (state) => state.existeResponsavelLogin,

    GET_MODAL_PJ_EDITAR_PESSOA: (state) => state.PJEditarPessoa,

    GET_MODAL_PJ_ADD_PESSOA_PEP: (state) => state.PJAddPessoaPep,

    GET_MODAL_PJ_EDITAR_PESSOA_PEP: (state) => state.PJEditarPessoaPep,

    GET_LISTA_REPRESENTANTES_PJ: (state) => state.listaRepresentantesPJ,

    GET_LISTA_PROCURADORES_PJ: (state) => state.listaProcuradoresPJ,

    GET_LISTA_PROCURADORES_FI: (state) => state.listaProcuradoresFI,

    GET_PJ_INFO_FINANCEIRA_EMPRESA: (state) => state.PJInfoFinanceiraEmpresa,

    GET_PJ_SALVAR_INFO_FINANCEIRO: (state) =>
        state.PJSalvarInfoFinanceiraEmpresa,

    GET_PJ_INFO_BANCARIOS: (state) => state.PJInfoBancario,

    GET_ABRIR_ALTERAR_SENHA: (state) => state.abrirAlterarSenha,

    GET_MODAL_AVISO_LOGIN: (state) => state.modalAvisoLogin,

    GET_MODAL_AVISO_GENERICO: (state) => state.modalAvisoGenerico,

    GET_MODAL_AVISO: (state) => state.modalAviso,

    GET_MODAL_AVISO_APROVACAO_PERSONALIZADA: (state) => state.modalAvisoAprovacaoPersonalizada,

    GET_PJ_SALVAR_INFO_BANCARIAS: (state) => state.PJSalvarInfoBancarias,

    GET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL: (state) =>
        state.PJSalvarInfoBancariasAdicional,

    GET_PJ_SALVAR_INFO_ENDERECO: (state) => state.PJSalvarInfoEndereco,

    GET_PJ_INFO_ENDERECO: (state) => state.PJInfoEndereco,

    GET_PJ_INFO_DECLARACOES: (state) => state.PJInfoDeclaracoes,

    GET_DISPENSA_QUESTIONARIO: (state) => state.DispensaQuestionarioConfig,

    GET_CONFIGURACAO: (state) => state.Configuracao,

    GET_CONFIGURACOES: (state) => (chave) => {
        return state.configuracoes[chave];
    },

    GET_PJ_SALVAR_INFO_DECLARACOES: (state) => state.PJSalvarInfoDeclaracoes,

    GET_FI_INFO_EMPRESA: (state) => state.FIInfoEmpresa,

    GET_FI_SALVAR_INFO_BASICAS: (state) => state.FISalvarInfoEmpresa,

    GET_FI_SALVAR_INFO: (state) => state.FISalvarInfo,

    GET_FI_INFO_FINANCEIRO: (state) => state.FIInfoFinanceiro,

    GET_FI_INFO_BANCARIO: (state) => state.FIInfoBancario,

    GET_FI_INFO_DECLARACAO: (state) => state.FIInfoDeclaracao,

    GET_FI_SALVAR_INFO_FINANCEIRO: (state) => state.FISalvarInfoFinanceiro,

    GET_PF_PJ_INFO_DISPENSA_QUESTIONARIO: (state) =>
        state.PF_PJ_InfoDispensaQuestionario,

    GET_PF_PJ_SALVAR_INFO_DISPENSA: (state) =>
        state.PF_PJ_SalvarDispensaQuestionario,

    GET_FI_SALVAR_INFO_EMISSOR_ORDEM: (state) => state.FISalvarInfoEmissorOrdem,

    GET_FI_SALVAR_INFO_BANCARIO: (state) => state.FISalvarInfoBancario,

    GET_FI_SALVAR_INFO_BANCARIO_ADICIONAL: (state) =>
        state.FISalvarInfoBancarioAdicional,

    GET_FI_SALVAR_INFO_DECLARACAO: (state) => state.FISalvarInfoDeclaracao,

    GET_FI_SALVAR_INFO_PARTICIPANTE: (state) => state.FISalvarInfoParticipante,

    GET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO: (state) =>
        state.habImpressaoDocumentos,

    GET_FI_INFO_PARTICIPANTE: (state) => state.FIInfoParticipante,

    GET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE: (state) =>
        state.FISalvarInfoParticipanteRepresentante,

    GET_FI_INFO_PARTICIPANTE_REPRESENTANTE: (state) =>
        state.FIInfoParticipanteRepresentante,

    GET_FI_INFO_EMISSOR_ORDEM: (state) => state.FIInfoEmissorOrdem,

    GET_MODAL_FI_ADD_PARTICIPANTE: (state) => state.FIAddParticipante,

    GET_MODAL_FI_EDITAR_PARTICIPANTE: (state) => state.FIEditarParticipante,

    GET_LISTA_PARTICIPANTES_FI: (state) => state.FIListaParticipantes,

    GET_MODAL_QUESTIONARIO: (state) => state.QuestionarioModalAbrir,

    GET_MODAL_LISTAR_QUESTIONARIO: (state) => state.QuestionarioListarPerguntas,

    GET_FICHA_CONCLUIR: (state) => state.fichaConcluir,

    GET_PF_SALVAR_INFO_CONTAS_ADICIONAIS: (state) =>
        state.PFSalvarContasAdicionais,

    GET_MODAL_PEP_INFORMATIVO: (state) => state.ModalPepInformativo,

    GET_MODAL_SAIBA_MAIS_INFORMATIVO: (state) =>
        state.ModalSaibaMaisInformativo,

    GET_SALVAR_INFO_UPLOAD: (state) => state.SalvarInfoUpload,

    GET_LISTA_PRODUTOS: (state) => state.listaProdutos,

    GET_LISTA_PRODUTOS_CLIENTE: (state) => state.listaProdutosCliente,

    GET_MODAL_TERMOS_PRODUTOS: (state) => state.ModalTermosProdutos,

    GET_MODAL_TERMOS_DOCUMENTOS: (state) => state.ModalTermosDocumentos,

    GET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE: (state) =>
        state.ModalTermosDocumentosBloquearAceite,

    GET_ENVIAR_CADASTRO: (state) => state.enviarCadastro,

    GET_PERFIL_CLIENTE: (state) => state.PerfilClienteQuestionario,

    GET_LISTA_MOTIVO_DISPENSA: (state) => state.listaMotivoDispensa,

    GET_MODAL_DISCLAIMER_INFORMATIVO: (state) =>
        state.ModalDisclaimerInformativo,

    GET_LISTA_DISCLAIMER: (state) => state.listaDisclaimer,

    GET_LISTA_REPRESENTANTES_FI: (state) => state.listaRepresentantesFI,

    GET_LISTA_ASSINANTES: (state) => state.listaAssinantes,

    GET_MODAL_ASSINATURA_STATUS: (state) => state.ModalAssinaturaStatus,

    GET_LISTA_STATUS_ASSINATURAS: (state) => state.listaAssinaturasStatus,

    GET_SALVAR_INFO_DES_NOTIFICACAO: (state) =>
        state.DesabilitarNotificacaoSalvar,

    GET_SITUACAO_DOCUMENTO_ASSINATURA: (state) =>
        state.situacaoDocumentoAssinatura,

    GET_LISTA_PEP_FI: (state) => state.listaPEPFI,

    GET_MODAL_VISUALIZAR_POSICAO: (state) => state.modalVisualizarPosicao, 

};

const mutations = {
    SET_LISTA_PRODUTOS: (state, listaProdutos) => {
        state.listaProdutos = listaProdutos;
    },
    SET_SALVAR_QUESTIONARIO: (state, salvarQuestionario) => {
        state.salvarQuestionario = salvarQuestionario;
    },
    SET_LISTA_ASSINANTES: (state, listaAssinantes) => {
        state.listaAssinantes = listaAssinantes;
    },
    SET_CREATE_ACCOUNT: (state, createAccount) => {
        state.createAccount = createAccount;
    },
    SET_ETAPA_CADASTRO: (state, etapaCadastro) => {
        state.etapaCadastro = etapaCadastro;
    },
   SET_ETAPA_CONCLUIDA: (state, etapaConcluida) => {
        if (etapaConcluida === null) {
            state.etapaConcluida = [];
        } else if (!state.etapaConcluida.includes(etapaConcluida)) {
            state.etapaConcluida.push(etapaConcluida);
        }
    },
    SET_PF_INFO_BASICAS: (state, PFInfoBasicas) => {
        state.PFInfoBasicas = PFInfoBasicas;
    },
    SET_PF_SALVAR_INFO_BASICAS: (state, PFSalvarInfoBasicas) => {
        state.PFSalvarInfoBasicas = PFSalvarInfoBasicas;
    },
    SET_SALVAR_INFO_UPLOAD: (state, SalvarInfoUpload) => {
        state.SalvarInfoUpload = SalvarInfoUpload;
    },
    SET_PF_SALVAR_INFO_BASICAS_REPRESENTANTES: (
        state,
        PFSalvarInfoBasicasRepresentantes
    ) => {
        state.PFSalvarInfoBasicasRepresentantes =
            PFSalvarInfoBasicasRepresentantes;
    },
    SET_PF_INFO_BASICAS_REPRESENTANTES: (
        state,
        PFInfoBasicasRepresentantes
    ) => {
        state.PFInfoBasicasRepresentantes = PFInfoBasicasRepresentantes;
    },
    SET_PF_SALVAR_INFO_DECLARACOES: (state, PFSalvarInfoDeclaracoes) => {
        state.PFSalvarInfoDeclaracoes = PFSalvarInfoDeclaracoes;
    },
    SET_LISTA_MOTIVO_DISPENSA: (state, listaMotivoDispensa) => {
        state.listaMotivoDispensa = listaMotivoDispensa;
    },
    SET_PF_SALVAR_INFO_ENDERECO: (state, PFSalvarInfoEndereco) => {
        state.PFSalvarInfoEndereco = PFSalvarInfoEndereco;
    },
    SET_PF_SALVAR_INFO_BANCARIAS: (state, PFSalvarInfoBancarias) => {
        state.PFSalvarInfoBancarias = PFSalvarInfoBancarias;
    },
    SET_PF_SALVAR_INFO_CONTAS_ADICIONAIS: (state, PFSalvarContasAdicionais) => {
        state.PFSalvarContasAdicionais = PFSalvarContasAdicionais;
    },
    SET_PF_SALVAR_INFO_FINANCEIRAS: (state, PFSalvarInfoFinanceiras) => {
        state.PFSalvarInfoFinanceiras = PFSalvarInfoFinanceiras;
    },
    SET_PF_INFO_FINANCEIRAS: (state, PFInfoFinanceiras) => {
        state.PFInfoFinanceiras = PFInfoFinanceiras;
    },
    SET_PF_INFO_BANCARIOS: (state, PFInfoBancarios) => {
        state.PFInfoBancarios = PFInfoBancarios;
    },
    SET_PERFIL_CLIENTE: (state, PerfilClienteQuestionario) => {
        state.PerfilClienteQuestionario = PerfilClienteQuestionario;
    },
    SET_DISPENSA_QUESTIONARIO: (state, DispensaQuestionarioConfig) => {
        state.DispensaQuestionarioConfig = DispensaQuestionarioConfig;
    },
    SET_CONFIGURACAO: (state, Configuracao) => {
        state.Configuracao = Configuracao;
    },
    SET_CONFIGURACOES(state, { chave, configuracao }) {
        if (!state.configuracoes) {
            state.configuracoes = {};
        }
        state.configuracoes[chave] = configuracao;
    },
    SET_LISTA_BANCOS: (state, listaBancos) => {
        state.listaBancos = listaBancos;
    },
    SET_LISTA_PAISES: (state, listaPaises) => {
        state.listaPaises = listaPaises;
    },
    SET_LISTA_NACIONALIDADES: (state, listaNacionalidades) => {
        state.listaNacionalidades = listaNacionalidades;
    },
    SET_LISTA_CIDADE: (state, listaCidade) => {
        state.listaCidade = listaCidade;
    },
    SET_LISTA_ORGAO_EMISSOR: (state, listaOrgaoEmissor) => {
        state.listaOrgaoEmissor = listaOrgaoEmissor;
    },
    SET_LISTA_DOCUMENTOS_UPLOAD: (state, listaDocumentosUpload) => {
        state.listaDocumentosUpload = listaDocumentosUpload;
    },
    SET_LISTA_DOCUMENTOS: (state, listaDocumentosDeclaracoes) => {
        state.listaDocumentosDeclaracoes = listaDocumentosDeclaracoes;
    },
    SET_LISTA_DOCUMENTOS_CLIENTE: (
        state,
        listaDocumentosDeclaracoesCliente
    ) => {
        state.listaDocumentosDeclaracoesCliente =
            listaDocumentosDeclaracoesCliente;
    },
    SET_LISTA_DOCUMENTOS_UPLOAD_REALIZADO: (
        state,
        listaDocumentosUploadRealizado
    ) => {
        state.listaDocumentosUploadRealizado = listaDocumentosUploadRealizado;
    },
    SET_LISTA_RAMO_ATIVIDADE: (state, listaRamoAtividade) => {
        state.listaRamoAtividade = listaRamoAtividade;
    },
    SET_LISTA_ATIVIDADES: (state, listaAtividades) => {
        state.listaAtividades = listaAtividades;
    },
    SET_LISTA_TIPOS_INVESTIDORES: (state, listaTiposInvestidores) => {
        state.listaTiposInvestidores = listaTiposInvestidores;
    },
    SET_LISTA_NATUREZA_JURIDICA: (state, listaNaturezaJuridica) => {
        state.listaNaturezaJuridica = listaNaturezaJuridica;
    },
    SET_LISTA_TIPOS_CLIENTES_PJ: (state, listaTiposClientesPJ) => {
        state.listaTiposClientesPJ = listaTiposClientesPJ;
    },
    SET_LISTA_PRODUTOS_CLIENTE: (state, listaProdutosCliente) => {
        state.listaProdutosCliente = listaProdutosCliente;
    },
    SET_PF_INFO_DECLARACOES: (state, PFInfoDeclaracoes) => {
        state.PFInfoDeclaracoes = PFInfoDeclaracoes;
    },
    SET_LISTA_OCUPACAO_PROFISSIONAL: (state, listaOcupacaoProfissional) => {
        state.listaOcupacaoProfissional = listaOcupacaoProfissional;
    },
    SET_LISTA_FORMACAO_PROFISSIONAL: (state, listaFormacaoProfissional) => {
        state.listaFormacaoProfissional = listaFormacaoProfissional;
    },
    SET_PF_SALVAR_INFO: (state, salvarInformacoes) => {
        state.salvarInformacoes = salvarInformacoes;
    },
    SET_FICHA_CONCLUIR: (state, fichaConcluir) => {
        state.fichaConcluir = fichaConcluir;
    },
    SET_SUITABILITY_PREVIEW: (state, suitabilityPreview) => {
        state.suitabilityPreview = suitabilityPreview;
    },
    //Referente a ficha de PJ
    SET_PJ_INFO_EMPRESA: (state, PJInfoEmpresa) => {
        state.PJInfoEmpresa = PJInfoEmpresa;
    },
    SET_PJ_INFO_COMPLEMENTO_EMPRESA: (state, PJInfoComplementoEmpresa) => {
        state.PJInfoComplementoEmpresa = PJInfoComplementoEmpresa;
    },
    SET_PJ_SALVAR_INFO_EMPRESA: (state, PJSalvarInfoEmpresa) => {
        state.PJSalvarInfoEmpresa = PJSalvarInfoEmpresa;
    },
    SET_SALVAR_INFO_DES_NOTIFICACAO: (state, DesabilitarNotificacaoSalvar) => {
        state.DesabilitarNotificacaoSalvar = DesabilitarNotificacaoSalvar;
    },
    SET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA: (
        state,
        PJSalvarInfoComplementoEmpresa
    ) => {
        state.PJSalvarInfoComplementoEmpresa = PJSalvarInfoComplementoEmpresa;
    },
    SET_PJ_INFO_COMPLEMENTO_SOCIOS: (state, PJInfoComplementoSocios) => {
        state.PJInfoComplementoSocios = PJInfoComplementoSocios;
    },
    SET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS: (
        state,
        PJSalvarInfoComplementoSocios
    ) => {
        state.PJSalvarInfoComplementoSocios = PJSalvarInfoComplementoSocios;
    },
    SET_PJ_INFO_FINANCEIRA_EMPRESA: (state, PJInfoFinanceiraEmpresa) => {
        state.PJInfoFinanceiraEmpresa = PJInfoFinanceiraEmpresa;
    },
    SET_ENVIAR_CADASTRO: (state, enviarCadastro) => {
        state.enviarCadastro = enviarCadastro;
    },
    SET_PJ_SALVAR_INFO: (state, PJSalvarInfo) => {
        state.PJSalvarInfo = PJSalvarInfo;
    },
    SET_MODAL_PJ_ADD_PESSOA_FATCA: (state, PJAddPessoa) => {
        state.PJAddPessoaFatca = PJAddPessoa
    },
    SET_MODAL_PJ_ADD_PESSOA: (state, payload) => {
        state.PJAddPessoa = payload.showModal;
        state.existeResponsavelLogin = payload.existeResponsavelLogin;
    },
    SET_ABRIR_ALTERAR_SENHA: (state, abrirAlterarSenha) => {
        state.abrirAlterarSenha = abrirAlterarSenha;
    },
    SET_MODAL_AVISO_LOGIN: (state, modalAvisoLogin) => {
        state.modalAvisoLogin = modalAvisoLogin;
    },
    SET_MODAL_AVISO_GENERICO: (state, modalAvisoGenerico) => {
        state.modalAvisoGenerico = modalAvisoGenerico;
    },
    SET_MODAL_AVISO: (state, modalAviso) => {
        state.modalAviso = modalAviso;
    },
    SET_MODAL_AVISO_APROVACAO_PERSONALIZADA: (state, modalAvisoAprovacaoPersonalizada) => {
        state.modalAvisoAprovacaoPersonalizada = modalAvisoAprovacaoPersonalizada;
    },
    SET_MODAL_PJ_ADD_PESSOA_PEP: (state, PJAddPessoaPep) => {
        state.PJAddPessoaPep = PJAddPessoaPep;
    },
    SET_MODAL_TERMOS_PRODUTOS: (state, ModalTermosProdutos) => {
        state.ModalTermosProdutos = ModalTermosProdutos;
    },
    SET_MODAL_TERMOS_DOCUMENTOS: (state, ModalTermosDocumentos) => {
        state.ModalTermosDocumentos = ModalTermosDocumentos;
    },
    SET_MODAL_ASSINATURA_STATUS: (state, ModalAssinaturaStatus) => {
        state.ModalAssinaturaStatus = ModalAssinaturaStatus;
    },
    SET_LISTA_REPRESENTANTES_PJ: (state, listaRepresentantesPJ) => {
        state.listaRepresentantesPJ = listaRepresentantesPJ;
    },
    SET_LISTA_PROCURADORES_PJ: (state, listaProcuradoresPJ) => {
        state.listaProcuradoresPJ = listaProcuradoresPJ;
    },
    SET_LISTA_PROCURADORES_FI: (state, listaProcuradoresFI) => {
        state.listaProcuradoresFI = listaProcuradoresFI;
    },
    SET_MODAL_PJ_EDITAR_PESSOA: (state, PJEditarPessoa) => {
        state.PJEditarPessoa = PJEditarPessoa;
    },
    SET_MODAL_PJ_EDITAR_PESSOA_PEP: (state, PJEditarPessoaPep) => {
        state.PJEditarPessoaPep = PJEditarPessoaPep;
    },
    SET_PJ_SALVAR_INFO_FINANCEIRO: (state, PJSalvarInfoFinanceiraEmpresa) => {
        state.PJSalvarInfoFinanceiraEmpresa = PJSalvarInfoFinanceiraEmpresa;
    },
    SET_PJ_INFO_BANCARIOS: (state, PJInfoBancario) => {
        state.PJInfoBancario = PJInfoBancario;
    },
    SET_PJ_SALVAR_INFO_BANCARIAS: (state, PJSalvarInfoBancarias) => {
        state.PJSalvarInfoBancarias = PJSalvarInfoBancarias;
    },
    SET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL: (
        state,
        PJSalvarInfoBancariasAdicional
    ) => {
        state.PJSalvarInfoBancariasAdicional = PJSalvarInfoBancariasAdicional;
    },
    SET_PJ_INFO_ENDERECO: (state, PJInfoEndereco) => {
        state.PJInfoEndereco = PJInfoEndereco;
    },
    SET_PJ_SALVAR_INFO_ENDERECO: (state, PJSalvarInfoEndereco) => {
        state.PJSalvarInfoEndereco = PJSalvarInfoEndereco;
    },
    SET_PJ_INFO_DECLARACOES: (state, PJInfoDeclaracoes) => {
        state.PJInfoDeclaracoes = PJInfoDeclaracoes;
    },
    SET_PJ_SALVAR_INFO_DECLARACOES: (state, PJSalvarInfoDeclaracoes) => {
        state.PJSalvarInfoDeclaracoes = PJSalvarInfoDeclaracoes;
    },
    SET_FI_INFO_EMPRESA: (state, FIInfoEmpresa) => {
        state.FIInfoEmpresa = FIInfoEmpresa;
    },
    SET_FI_SALVAR_INFO_BASICAS: (state, FISalvarInfoEmpresa) => {
        state.FISalvarInfoEmpresa = FISalvarInfoEmpresa;
    },
    SET_FI_SALVAR_INFO: (state, FISalvarInfo) => {
        state.FISalvarInfo = FISalvarInfo;
    },
    SET_FI_SALVAR_INFO_FINANCEIRO: (state, FISalvarInfoFinanceiro) => {
        state.FISalvarInfoFinanceiro = FISalvarInfoFinanceiro;
    },
    SET_FI_SALVAR_INFO_BANCARIO: (state, FISalvarInfoBancario) => {
        state.FISalvarInfoBancario = FISalvarInfoBancario;
    },
    SET_PF_PJ_SALVAR_INFO_DISPENSA: (
        state,
        PF_PJ_SalvarDispensaQuestionario
    ) => {
        state.PF_PJ_SalvarDispensaQuestionario =
            PF_PJ_SalvarDispensaQuestionario;
    },
    SET_FI_SALVAR_INFO_BANCARIO_ADICIONAL: (
        state,
        FISalvarInfoBancarioAdicional
    ) => {
        state.FISalvarInfoBancarioAdicional = FISalvarInfoBancarioAdicional;
    },
    SET_FI_SALVAR_INFO_DECLARACAO: (state, FISalvarInfoDeclaracao) => {
        state.FISalvarInfoDeclaracao = FISalvarInfoDeclaracao;
    },
    SET_FI_INFO_FINANCEIRO: (state, FIInfoFinanceiro) => {
        state.FIInfoFinanceiro = FIInfoFinanceiro;
    },
    SET_FI_INFO_BANCARIO: (state, FIInfoBancario) => {
        state.FIInfoBancario = FIInfoBancario;
    },
    SET_FI_INFO_DECLARACAO: (state, FIInfoDeclaracao) => {
        state.FIInfoDeclaracao = FIInfoDeclaracao;
    },
    SET_FI_INFO_PARTICIPANTE: (state, FIInfoParticipante) => {
        state.FIInfoParticipante = FIInfoParticipante;
    },
    SET_FI_SALVAR_INFO_PARTICIPANTE: (state, FISalvarInfoParticipante) => {
        state.FISalvarInfoParticipante = FISalvarInfoParticipante;
    },
    SET_FI_SALVAR_INFO_EMISSOR_ORDEM: (state, FISalvarInfoEmissorOrdem) => {
        state.FISalvarInfoEmissorOrdem = FISalvarInfoEmissorOrdem;
    },
    SET_FI_INFO_PARTICIPANTE_REPRESENTANTE: (
        state,
        FIInfoParticipanteRepresentante
    ) => {
        state.FIInfoParticipanteRepresentante = FIInfoParticipanteRepresentante;
    },
    SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE: (
        state,
        FISalvarInfoParticipanteRepresentante
    ) => {
        state.FISalvarInfoParticipanteRepresentante =
            FISalvarInfoParticipanteRepresentante;
    },
    SET_MODAL_FI_ADD_PARTICIPANTE: (state, FIAddParticipante) => {
        state.FIAddParticipante = FIAddParticipante;
    },
    SET_MODAL_FI_EDITAR_PARTICIPANTE: (state, FIEditarParticipante) => {
        state.FIEditarParticipante = FIEditarParticipante;
    },
    SET_LISTA_PARTICIPANTES_FI: (state, FIListaParticipantes) => {
        state.FIListaParticipantes = FIListaParticipantes;
    },
    SET_MODAL_QUESTIONARIO: (state, QuestionarioModalAbrir) => {
        state.QuestionarioModalAbrir = QuestionarioModalAbrir;
    },
    SET_MODAL_LISTAR_QUESTIONARIO: (state, QuestionarioListarPerguntas) => {
        state.QuestionarioListarPerguntas = QuestionarioListarPerguntas;
    },
    SET_MODAL_PEP_INFORMATIVO: (state, ModalPepInformativo) => {
        state.ModalPepInformativo = ModalPepInformativo;
    },
    SET_MODAL_SAIBA_MAIS_INFORMATIVO: (state, ModalSaibaMaisInformativo) => {
        state.ModalSaibaMaisInformativo = ModalSaibaMaisInformativo;
    },
    SET_MODAL_DISCLAIMER_INFORMATIVO: (state, ModalDisclaimerInformativo) => {
        state.ModalDisclaimerInformativo = ModalDisclaimerInformativo;
    },
    SET_LISTA_DISCLAIMER: (state, listaDisclaimer) => {
        state.listaDisclaimer = listaDisclaimer;
    },
    SET_LISTA_REPRESENTANTES_FI: (state, listaRepresentantesFI) => {
        state.listaRepresentantesFI = listaRepresentantesFI;
    },
    SET_LISTA_PEP_FI: (state, listaPEPFI) => {
        state.listaPEPFI = listaPEPFI;
    },
    SET_FI_INFO_EMISSOR_ORDEM: (state, FIInfoEmissorOrdem) => {
        state.FIInfoEmissorOrdem = FIInfoEmissorOrdem;
    },
    SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE: (
        state,
        ModalTermosDocumentosBloquearAceite
    ) => {
        state.ModalTermosDocumentosBloquearAceite =
            ModalTermosDocumentosBloquearAceite;
    },
    SET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO: (state, habImpressaoDocumentos) => {
        state.habImpressaoDocumentos = habImpressaoDocumentos;
    },

    SET_MODAL_CADASTRO_VENCIDO: (state, modalCadastroVencido) => {
        state.modalCadastroVencido = modalCadastroVencido;
    },

    SET_PF_PJ_INFO_DISPENSA_QUESTIONARIO: (
        state,
        PF_PJ_InfoDispensaQuestionario
    ) => {
        state.PF_PJ_InfoDispensaQuestionario = PF_PJ_InfoDispensaQuestionario;
    },
    SET_LISTA_STATUS_ASSINATURAS: (state, listaAssinaturasStatus) => {
        state.listaAssinaturasStatus = listaAssinaturasStatus;
    },
    SET_SITUACAO_DOCUMENTO_ASSINATURA: (state, situacaoDocumentoAssinatura) => {
        state.situacaoDocumentoAssinatura = situacaoDocumentoAssinatura;
    },

    SET_MODAL_VISUALIZAR_POSICAO: (state, modalVisualizarPosicao) => {  // <-- ADICIONE ESTAS LINHAS
        state.modalVisualizarPosicao = modalVisualizarPosicao;
    },
};

const actions = {
    //Referente a ficha de Fundos de Investimento
    FETCH_QUESTIONARIO_BUSCAR_QUESTOES: async ({ commit }) => {
        
        const { data } = await api.get(`/questionario`);
        commit("SET_MODAL_LISTAR_QUESTIONARIO", data.data);
    },
    FETCH_FI_INFO_PARTICIPANTE_CUSTODIANTE: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/emissorOrdem`
        );
        commit("SET_LISTA_PARTICIPANTES_FI", data.data);
    },
    FETCH_FI_INFO_PARTICIPANTE: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/participante`
        );
        commit("SET_FI_INFO_PARTICIPANTE", data.data);
    },
    FETCH_FI_INFO_PARTICIPANTE_REPRESENTANTE: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/representante`
        );
        commit("SET_FI_INFO_PARTICIPANTE_REPRESENTANTE", data.data);
    },
    FETCH_FI_INFO_EMISSOR_ORDEM: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/pessoaAutorizadaEmitirOrdem`
        );
        commit("SET_FI_INFO_EMISSOR_ORDEM", data.data);
    },
    FETCH_FI_INFO_EMPRESA: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/informacaoBasica`
        );
        commit("SET_FI_INFO_EMPRESA", data.data);
    },
    FETCH_FI_INFO_FINANCEIRO: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/dadosFinanceiros`
        );
        commit("SET_FI_INFO_FINANCEIRO", data.data);
    },
    FETCH_FI_INFO_BANCARIO: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/dadosBancarios`
        );
        commit("SET_FI_INFO_BANCARIO", data.data);
    },
    FETCH_FI_INFO_DECLARACAO: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/declaracoes`
        );
        commit("SET_FI_INFO_DECLARACAO", data.data);
    },
    //Referente a ficha de PJ
    FETCH_PJ_LISTA_REPRESENTANTES: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/representante`
        );
        commit("SET_LISTA_REPRESENTANTES_PJ", data.data);
    },
    FETCH_PJ_LISTA_PROCURADORES: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/representante?tipo=procurador`
        );
        commit("SET_LISTA_PROCURADORES_PJ", data.data);
    },
    FETCH_PJ_LISTA_ASSINANTES: async ({ commit }) => {
        
        const { data } = await api.get(
            `/declaracao/assinantes`
        );
        commit("SET_LISTA_ASSINANTES", data.data);
    },
    FETCH_PJ_LISTA_STATUS_ASSINATURA: async ({ commit }, GuidDeclaracao) => {
        
        const { data } = await api.get(
            `/declaracao/assinaturas?guidDeclaracao=${GuidDeclaracao}`
        );
        commit("SET_LISTA_STATUS_ASSINATURAS", data.data);
    },
    FETCH_FI_LISTA_PROCURADORES: async ({ commit }) => {
        
        const { data } = await api.get(
            `/Fundo/procurador`
        );
        commit("SET_LISTA_PROCURADORES_FI", data.data);
    },
    FETCH_FI_LISTA_REPRESENTANTES: async ({ commit }) => {
        
        const { data } = await api.get(`/Fundo/facta`);
        commit("SET_LISTA_REPRESENTANTES_FI", data.data);
    },
    FETCH_FI_LISTA_PEP: async ({ commit }) => {
        
        const { data } = await api.get(`/Fundo/pep`);
        commit("SET_LISTA_PEP_FI", data.data);
    },
    FETCH_PF_LISTA_REPRESENTANTES: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaFisica/representante`
        );
        commit("SET_LISTA_REPRESENTANTES_PJ", data.data);
    },
    FETCH_PJ_INFO_FINANCEIRA: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/dadosFinanceiros`
        );
        commit("SET_PJ_INFO_FINANCEIRA_EMPRESA", data.data);
    },
    FETCH_PJ_INFO_EMPRESA: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/informacaoBasica`
        );
        commit("SET_PJ_INFO_EMPRESA", data.data);
    },
    FETCH_PJ_INFO_COMPLEMENTO_EMPRESA: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/empresas`
        );
        commit("SET_PJ_INFO_COMPLEMENTO_EMPRESA", data.data);
    },
    FETCH_PJ_INFO_COMPLEMENTO_SOCIOS: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/socios`
        );
        commit("SET_PJ_INFO_COMPLEMENTO_SOCIOS", data.data);
    },
    FETCH_PJ_INFO_BANCARIOS: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/dadosBancarios`
        );
        commit("SET_PJ_INFO_BANCARIOS", data.data);
    },
    FETCH_PJ_INFO_ENDERECO: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/endereco`
        );
        commit("SET_PJ_INFO_ENDERECO", data.data);
    },
    FETCH_PJ_INFO_DECLARACOES: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaJuridica/declaracoes`
        );
        commit("SET_PJ_INFO_DECLARACOES", data.data);
    },
    FETCH_DISPENSA_QUESTIONARIO: async ({ commit }) => {
        
        const { data } = await api.get(
            `/suitability/consulta-dispensa-questionario`
        );
        commit("SET_PF_PJ_INFO_DISPENSA_QUESTIONARIO", data.data);
    },
    FETCH_PERFIL_CLIENTE: async ({ commit }) => {
        
        const { data } = await api.get(`/suitability`);
        commit("SET_PERFIL_CLIENTE", data.data);
    },
    FETCH_VERIFICAR_DISPENSA_QUESTIONARIO: async ({ commit }) => {
        
        const { data } = await api.get(`/consulta/configuracao-geral`);
        commit("SET_DISPENSA_QUESTIONARIO", data.data);
    },
    FETCH_CONFIGURACAO: async ({ commit }, chave) => {
        
        const { data } = await api.get(
            `/consulta/configuracao-geral-chave?chave=${chave}`
        );
        commit("SET_CONFIGURACAO", data.data);
    },
    async FETCH_CONFIGURACOES({ commit }, chaves) {
        try {
            
            const promises = chaves.map((chave) =>
                api.get(`/consulta/configuracao-geral-chave?chave=${chave}`)
            );
            const responses = await Promise.all(promises);
            responses.forEach((response, index) => {
                commit("SET_CONFIGURACOES", {
                    chave: chaves[index],
                    configuracao: response.data.data,
                });
            });
        } catch (error) {
            console.error("Erro ao buscar configurações:", error);
        }
    },
    FETCH_BUSCA_LISTA_MOTIVO_DISPENSA: async ({ commit }) => {
        
        const { data } = await api.get(`/suitability/motivo-dispensa`);
        commit("SET_LISTA_MOTIVO_DISPENSA", data.data);
    },
    FETCH_CONSULTA_TIPOS_INVESTIDORES: async ({ commit }) => {
        
        const { data } = await api.get(`/tipoInvestidor`);
        commit("SET_LISTA_TIPOS_INVESTIDORES", data.data);
    },
    FETCH_CONSULTA_NATUREZA_JURIDICA: async ({ commit }) => {
        
        const { data } = await api.get(`/Consulta/naturezaJuridica`);
        commit("SET_LISTA_NATUREZA_JURIDICA", data.data);
    },
    
    FETCH_CONSULTA_TIPOS_CLIENTES_PJ: async ({ commit }) => {
        
        const { data } = await api.get(`/tipoClientePJ`);
        commit("SET_LISTA_TIPOS_CLIENTES_PJ", data.data);
    },
    //Referente a ficha de PF
    FETCH_PF_INFO_BASICAS: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaFisica/informacaoBasica`
        );
        commit("SET_PF_INFO_BASICAS", data.data);
    },
    FETCH_PF_INFO_BASICAS_REPRESENTANTES: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaFisica/Representante`
        );
        commit("SET_PF_INFO_BASICAS_REPRESENTANTES", data.data);
    },
    FETCH_PF_INFO_FINANCEIRAS: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaFisica/dadosFinanceiros`
        );
        commit("SET_PF_INFO_FINANCEIRAS", data.data);
    },
    FETCH_PF_INFO_BANCARIOS: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaFisica/dadosBancarios`
        );
        commit("SET_PF_INFO_BANCARIOS", data.data);
    },
    FETCH_PF_INFO_DECLARACOES: async ({ commit }) => {
        
        const { data } = await api.get(
            `/PessoaFisica/declaracoes`
        );
        commit("SET_PF_INFO_DECLARACOES", data.data);
    },
    FETCH_CONSULTA_BANCOS: async ({ commit }) => {
        
        const { data } = await api.get(`/Consulta/bancos`);
        commit("SET_LISTA_BANCOS", data.data);
    },
    FETCH_CONSULTA_PAISES: async ({ commit }) => {
        
        const { data } = await api.get(`/cliente/paisesObjetos`);
        commit("SET_LISTA_PAISES", data.data);
    },
    FETCH_CONSULTA_NACIONALIDADES: async ({ commit }) => {
        
        const { data } = await api.get(`/Consulta/nacionalidades`);
        commit("SET_LISTA_NACIONALIDADES", data.data);
    },

    FETCH_CONSULTA_CIDADES: async ({ commit }, uf) => {
        const { data } = await api.get(`/Consulta/cidades?uf=${uf}`);
        commit("SET_LISTA_CIDADE", data.data);
    },

    FETCH_CONSULTA_ORGAO_EMISSOR: async ({ commit }) => {
        const { data } = await api.get(`/Consulta/OrgaoEmissor`);
        commit("SET_LISTA_ORGAO_EMISSOR", data.data);
    },

    FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD: async ({ commit }) => {
        
        const { data } = await api.get(`/tipoDocumento`);
        commit("SET_LISTA_DOCUMENTOS_UPLOAD", data.data);
    },
    FETCH_CONSULTA_LISTA_PRODUTOS_PREVIEW: async ({ commit }, idPerfilRiscoPreview) => {
        try {
            const { data } = await api.get(`/produto?idPerfilRiscoPreview=${idPerfilRiscoPreview}`);
            commit("SET_LISTA_PRODUTOS", data.data);
        } catch (error) {
            if (error.response && error.response.status === 400) {
                // Trata o erro específico de status 400
                console.error(
                    "Erro 400: Não foi possível encontrar produtos com os critérios fornecidos."
                );
                // Você pode exibir uma mensagem de erro mais amigável para o usuário
                //this.errorMessage = "Não foi possível encontrar produtos com os critérios fornecidos.";
            } else {
                // Trata outros possíveis erros de rede ou servidor
                console.error("Erro ao acessar a API:", error.message);
                //this.errorMessage = "Houve um problema ao acessar a API de produtos.";
            }
            commit("SET_LISTA_PRODUTOS", null);
        }
    },
    FETCH_CONSULTA_LISTA_PRODUTOS: async ({ commit }) => {
        try {
            
            const { data } = await api.get(`/produto`);
            commit("SET_LISTA_PRODUTOS", data.data);
        } catch (error) {
            if (error.response && error.response.status === 400) {
                // Trata o erro específico de status 400
                console.error(
                    "Erro 400: Não foi possível encontrar produtos com os critérios fornecidos."
                );
                // Você pode exibir uma mensagem de erro mais amigável para o usuário
                //this.errorMessage = "Não foi possível encontrar produtos com os critérios fornecidos.";
            } else {
                // Trata outros possíveis erros de rede ou servidor
                console.error("Erro ao acessar a API:", error.message);
                //this.errorMessage = "Houve um problema ao acessar a API de produtos.";
            }
            commit("SET_LISTA_PRODUTOS", null);
        }
    },
    FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE: async ({ commit }) => {
        
        const { data } = await api.get(
            `/cliente/produtos`
        );
        commit("SET_LISTA_PRODUTOS_CLIENTE", data.data);
    },
    FETCH_CONSULTA_LISTA_DOCUMENTOS: async ({ commit }) => {
        try {
            
            const { data } = await api.get(`/declaracao`);
            commit("SET_LISTA_DOCUMENTOS", data.data);
        } catch (error) {
            if (error.response && error.response.status === 400) {
                // Trata o erro específico de status 400
                console.error(
                    "Erro 400: Não foi possível encontrar documentos com os critérios fornecidos."
                );
                // Você pode exibir uma mensagem de erro mais amigável para o usuário
                //this.errorMessage = "Não foi possível encontrar produtos com os critérios fornecidos.";
            } else {
                // Trata outros possíveis erros de rede ou servidor
                console.error("Erro ao acessar a API:", error.message);
                //this.errorMessage = "Houve um problema ao acessar a API de produtos.";
            }
        }
    },
    FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE: async ({ commit }) => {
        
        const { data } = await api.get(
            `/declaracao/cliente`
        );
        commit("SET_LISTA_DOCUMENTOS_CLIENTE", data.data);
    },
    FETCH_CONSULTA_ASSINANTE_DOCUMENTO: async (
        { commit },
        DocumentoAssinaturaGuid
    ) => {
        
        const { data } = await api.get(
            `/declaracao/assinaturas/consultarDeclaracaoParaAssinatura?guidDeclaracao=${DocumentoAssinaturaGuid}`
        );
        commit("SET_SITUACAO_DOCUMENTO_ASSINATURA", data.data);
    },
    FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO: async (
        { commit }) => {
        
        const { data } = await api.get(
            `/cliente/documentosSemAnexo`
        );
        commit("SET_LISTA_DOCUMENTOS_UPLOAD_REALIZADO", data.data);
    },
    FETCH_CONSULTA_RAMO_ATIVIDADE: async ({ commit }) => {
        
        const { data } = await api.get(`/Consulta/bancos`);
        commit("SET_LISTA_RAMO_ATIVIDADE", data.data);
    },
    FETCH_CONSULTA_ATIVIDADES: async ({ commit }, tipoCliente) => {
        
        const { data } = await api.get(
            `/Consulta/cnae?tipoCliente=${tipoCliente}`
        );
        const arrayDeObjetos = Object.keys(data.data).map((key) => ({
            id: key,
            descricao: data.data[key],
        }));
        commit("SET_LISTA_ATIVIDADES", arrayDeObjetos);
    },
    FETCH_CONSULTA_OCUPACAO_PROFISSIONAL: async ({ commit }) => {
        
        const { data } = await api.get(`/Consulta/ocupacao-profissional`);
        commit("SET_LISTA_OCUPACAO_PROFISSIONAL", data.data);
    },
    FETCH_CONSULTA_FORMACAO_PROFISSIONAL: async ({ commit }) => {
        
        const { data } = await api.get(`/Consulta/formacao-profissional`);
        commit("SET_LISTA_FORMACAO_PROFISSIONAL", data.data);
    },
    FETCH_CONSULTA_DISCLAIMER: async ({ commit }) => {
        
        const { data } = await api.get(`/Disclaimer`);
        commit("SET_LISTA_DISCLAIMER", data.data);
    },
    //Fim ficha PF
};

export default {
    state,
    getters,
    mutations,
    actions,
};
